import API from "../config/api.js";


export const OtherIncomeService = {

  async getIncomeAccounts() {
    try {
      const response = await API.get('/api/gl-accounts/accounts');
      return response.data;
    } catch (error) {
      console.error("Error fetching GL accounts:", error);
      throw error;
    }
  },
  async getIncomeAccountList(search = "", page = 1) {
    try {
      const response = await API.get(`/api/income_type/list/se=${search}`, {
        params: {
          page: page,
        },
      });
      return response;
    } catch (error) {
      console.error("Error fetching Income Accounts:", error);
      throw error;
    }
  },


  async AddOtherIncomeType(formData) {
    try {
      const response = await API.post('/api/income_type/create', formData);
      return response.data;
    } catch (error) {
      console.error("Error Adding Income Type:", error);
      throw error;
    }
  },

  async getIncomeTypeByUuid(uuid) {
    try {
      const response = await API.get(`api/income_type/info/${uuid}`)
      return response.data.data;
    }
    catch (error) {
      console.error("Error Fetching Income Details:", error);
      throw error;
    }
  },

  async updateOtherIncome(uuid, formData) {

    try {
      const response = await API.put(`/api/income_type/info/update/${uuid}`, formData);
      console.log('Response from API:', response);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Unexpected response status: ' + response.status);
      }
    } catch (error) {
      console.error('Error updating Other Income Type:', error);
      if (error.response) {
        console.error('API Response Error:', error.response.data);
      }
      throw error;
    }
  },

  async dropMember(uuid) {
    try {
      const response = await API.delete(`api/income_type/delete/${uuid}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting the Other Income Type:", error);
      throw error;
    }
  },

  //add other income entrie
  async logIncomeEntry(formData) {

    try {
      const response = await API.post('/api/income_type/other/create', formData);
      return response.data;
    } catch (error) {
      console.error("Error Adding Income Log:", error);
      throw error;
    }

  },

  //get all other income entries
  async getIncomeEntriesList(search = "", page = 1) {
    try {
      const response = await API.get(`/api/income_type/other/list/se=${search}`, {
        params: {
          page: page,
        },
      });

      return response;
    } catch (error) {
      console.error("Error fetching Income Accounts:", error);
      throw error;
    }
  },

  //get income spcific entry details
  async getIncomeEntryDetails(uuid) {
    return API.get(`api/income_type/other/info/${uuid}`);
  },
  //update income entry
  async updateIncomeEntry(data, uuid) {
    const response = await API.put(`/api/income_type/other/info/update/${uuid}`, data);
    return response;
  }





}